import "../../styles/Card.css";
import "./menu.css";

import Item from "../../Components/Item";
import { useEffect, useState } from "react";
import { CartLayout } from "../../Components/CartLayout";
import { useCart } from "../../Components/cart-context";

export function Menu({ mu }) {
  const [cartOpen, setCartOpen] = useState(false);
  const { items, addItem } = useCart();
  const [MenuItems, setMenuItems] = useState([]);
  const [isViewing, setIsViewing] = useState(false);
  const [currentItem, setCurrentItem] = useState({});
  const branchToken = localStorage.getItem("b");

  useEffect(() => {
    document.querySelector("title").textContent = "MAED | Menu";
    document.querySelectorAll(".navbar").forEach((nav) => {
      nav.classList.toggle("active", false);
      if (nav.getAttribute("data-id") === "Menu") {
        nav.classList.toggle("active", true);
      }
    });
    setMenuItems(mu);

    /* axios
      .get(`${process.env.REACT_APP_API_URL}/menu?b=${branchToken}`)
      .then((res) => {
        if (res.data.message === "Unregistered branch") {
          alert(res.data.message);
        } else {
          setMenuItems(res.data.data);

          document
            .getElementById("loading-wrapper")
            .classList.toggle("off", true);
        }
      }); */
    console.log("Menu effect");
  }, [items, mu]);
  function viewItem(e, item) {
    setIsViewing(true);
    setCurrentItem(item);
  }

  function ItemPreview({ item }) {
    return (
      <div
        className={`${isViewing ? "select-amount-wrapper" : "select-amount-wrapper hidden"}`}
      >
        <div className="card-img">
          <img src={`./images/${item.name}.webp`} alt="logo" loading="lazy" />
        </div>

        <section className="item-info">
          <p name="item_name" className="card-title">
            {item.name}
          </p>
          <p name="item_desc" className="card-description" value=" ">
            {item.description}
          </p>
        </section>
        <h2 className="price">
          {item.price}
          <span>.00</span>
        </h2>
        <section className="card-interact-btn-section">
          <button
            className="p-btn"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setIsViewing(false);
              setCurrentItem({});
              addItem({
                id: item.id,
                name: item.name,
                price: item.price,
                quantity: 1,
              });
            }}
          >
            ADD TO ORDER
          </button>
          <button
            className="s-btn"
            onClick={() => {
              setIsViewing(false);
              setCurrentItem({});
            }}
          >
            Back
          </button>
        </section>
        {/*<fieldset className="buy-options-container"></fieldset>*/}
      </div>
    );
  }

  const dealItem = {
    name: "Steak Sandwich Meal",
    description:
      "Steak sandwich + Side of Loaded Fries or Loaded Salad + Soft Drink",
    price: 500,
  }

  return (
    <>
      <main>
        <h2 style={{ color: 'white' }}>Deals</h2>
        <div className="card special rounded" onClick={(e) => {
          e.stopPropagation();
          viewItem(e, dealItem);
        }}>

          <img
            className="card-img"
            src={`./images/${dealItem.name}.webp`}
            alt="logo"
          />

          <p className="card-title">{dealItem.name}</p>
          <p className="card-description">
            {dealItem.description}
          </p>
          <p className="card-price">{dealItem.price}</p>



        </div>
        <h2 style={{ color: 'white' }}>Menu</h2>
        {MenuItems.map((item, index) => {
          return (
            <Item
              key={index}
              item={item.products}
              viewItem={viewItem}
              qty={item.quantity}
            />
          );
        })}
        <button
          onClick={() => {
            setCartOpen(true);
          }}
          className={
            items.length > 0
              ? "cart-opener-btn p-btn"
              : "cart-opener-btn p-btn off"
          }
        >
          <img src="/icons/cart.svg" alt="cart-logo" />
        </button>
      </main>
      <CartLayout
        className={cartOpen ? "on" : ""}
        onClose={() => setCartOpen(false)}
        branchToken={branchToken}
      />
      {<ItemPreview item={currentItem} />}
    </>
  );
}
